var url
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
    url = 'http://127.0.0.1:8000/api/v1';
    // url = 'https://api.qc-lab.ir/api/v1';
else
    url = 'https://api.qc-lab.ir/api/v1';
export const BASE_URL = url;

var media_url;
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
    media_url = 'http://127.0.0.1:8000';
else
    media_url = 'https://api.qc-lab.ir';
export const BASE_MEDIA_URL = media_url;

export const ITEMS_PER_PAGE = 10;